import { h } from '@stencil/core';
export class CommerceConnectorPrice {
  constructor() {
    this.productId = undefined;
    this.price = undefined;
    this.priceFromLabel = undefined;
  }
  priceBroadcastHandler(event) {
    const { detail: { prices, priceFromLabel }, } = event;
    if (this.productId in prices) {
      this.price = prices[this.productId];
      this.priceFromLabel = priceFromLabel;
    }
  }
  render() {
    if (!this.price) {
      return;
    }
    return h("div", { class: "pes-cc-price" }, h("span", { class: "pes-cc-price__label" }, this.priceFromLabel), h("span", null, this.price));
  }
  static get is() { return "pes-cc-price"; }
  static get originalStyleUrls() {
    return {
      "$": ["price.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["price.css"]
    };
  }
  static get properties() {
    return {
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "price": {},
      "priceFromLabel": {}
    };
  }
  static get listeners() {
    return [{
        "name": "ccBroadcastPrices",
        "method": "priceBroadcastHandler",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
